import { render, staticRenderFns } from "./GroupItemsModal.vue?vue&type=template&id=5632583d&scoped=true"
import script from "./GroupItemsModal.vue?vue&type=script&lang=js"
export * from "./GroupItemsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5632583d",
  null
  
)

export default component.exports